module.exports = __webpack_public_path__ + "img/phone_icon.e579b49d.png";